import { Fragment } from 'react';
import { Outlet, Link } from 'react-router-dom';
import NavBar from '../../components/navbar/NavBar';
import ScreenToggleButton from '../../components/screen-toggle-button/ScreenToggleButton';
import WittnerLogo from '../../assets/logo/wittner-logo.PNG';
import { FaInstagram } from 'react-icons/fa6';
import './Navigation.styles.scss';

const Navigation = () => {
  return ( 
    <Fragment>
      <div className="navigation-container">
        <nav className="navigation">
          <Link className="logo-container" to="/">
            <img src={WittnerLogo} alt="Museum Logo" />
          </Link>
          <div className="nav-center">
            <NavBar />
          </div>
          <div className="svgs-container">
            <div className="instagram-icon-box">
              <Link className="instagram" to="https://www.instagram.com/wittnermuseum/?hl=en" target="_blank">
                <FaInstagram />
              </Link>
            </div>
            <div className="toggle-icon-box">
              <div className="screen-toggle-nav">
                <ScreenToggleButton />
              </div>
            </div>
          </div>
        </nav>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;